// Descriptive command identifiers for demo actions
export enum DemoCommand {
  ADD_HEALTHCARE_FUNNELS = 'add-healthcare-funnels',
  ADD_TREATMENT_REVIEW_STAGE = 'add-treatment-review-stage', 
  ADD_METADATA_AND_CONNECT = 'add-metadata-and-connect',
  RESET_DEMO = 'reset-demo'
}

// Default user-facing chat commands
export const DEFAULT_CHAT_COMMANDS: Record<DemoCommand, string> = {
  [DemoCommand.ADD_HEALTHCARE_FUNNELS]: 'add-funnels',
  [DemoCommand.ADD_TREATMENT_REVIEW_STAGE]: 'add-stage',
  [DemoCommand.ADD_METADATA_AND_CONNECT]: 'add-metadata',
  [DemoCommand.RESET_DEMO]: 'reset'
};

// Command descriptions for UI
export const COMMAND_DESCRIPTIONS: Record<DemoCommand, string> = {
  [DemoCommand.ADD_HEALTHCARE_FUNNELS]: 'Add Healthcare Funnels (New Patient Intake + Active Patient Care)',
  [DemoCommand.ADD_TREATMENT_REVIEW_STAGE]: 'Add Treatment Review Stage (between In Treatment → Completed)',
  [DemoCommand.ADD_METADATA_AND_CONNECT]: 'Add Treatment Flow Metadata & Connect to Treatment Review',
  [DemoCommand.RESET_DEMO]: 'Reset Demo (Delete all healthcare funnels & metadata)'
};

export type ChatCommandMapping = Record<DemoCommand, string>;

// Delay configuration for actions (in seconds)
export type DelayConfiguration = {
  [DemoCommand.ADD_HEALTHCARE_FUNNELS]: number;
  [DemoCommand.ADD_TREATMENT_REVIEW_STAGE]: number;
  [DemoCommand.ADD_METADATA_AND_CONNECT]: number;
  // Note: RESET_DEMO doesn't need delay as specified
};

// Default delay values (2 seconds as requested)
export const DEFAULT_DELAYS: DelayConfiguration = {
  [DemoCommand.ADD_HEALTHCARE_FUNNELS]: 2,
  [DemoCommand.ADD_TREATMENT_REVIEW_STAGE]: 2,
  [DemoCommand.ADD_METADATA_AND_CONNECT]: 2,
};